module.exports = __webpack_public_path__ + "img/stop-5.e279174a.jpg";